import React, {FC, useMemo} from "react"
import {ContestReward} from "@jnext/ts-axios-contestformat"
import {isRewardItem, toFlatAmbiguousContestRewards} from "../../../lib/utils/rewards"
import {JSlider} from "../../JSlider"
import {SLIDER_4X} from "../../configs"
import {JCardRewardItem, JCardRewardWallet} from "../../../JCMSCard/components"

export interface JSliderRewardProps {
    rewards: ContestReward[]
}
export const JSliderReward: FC<JSliderRewardProps> = ({ rewards }) => {
    const flatRewards = useMemo(()=>toFlatAmbiguousContestRewards(rewards), [rewards])
    
    return (
        <JSlider {...SLIDER_4X}>
            {
                flatRewards.map((reward, i) => (
                    isRewardItem(reward) ? (
                        <JCardRewardItem {...reward} key={i}  quantityPerPeriod={rewards?.[i]?.quantityPerPeriod} distributionType={rewards?.[i]?.distributionType} />
                    ) : (                        
                        <JCardRewardWallet {...reward} key={i}/>
                    )
                ))
            }
        </JSlider>
    )
}

